export default __webpack_public_path__ + "static/media/B52_22.40104112.webp";